"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackJSAgent = TrackJSAgent;
const trackjs_1 = require("trackjs");
const react_1 = require("react");
function TrackJSAgent(props) {
    (0, react_1.useEffect)(() => {
        if (!trackjs_1.TrackJS.isInstalled()) {
            trackjs_1.TrackJS.install(props.config);
            trackjs_1.TrackJS.addMetadata("next-execution", "client");
            window.TrackJS = trackjs_1.TrackJS;
        }
    }, []);
    return null;
}
